/**
 * Default settings for calendars
 */
export const LOCALE = {
  direction: "ltr",
  format: "dd-mm-yyyy",
  separator: " > ",
  applyLabel: "אישור",
  cancelLabel: "ביטול",
  daysOfWeek: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
  monthNames: [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר"
  ]
};

/**
 * Initial settings for appointment
 * columns.
 */
export const APPOINTMENT_COLUMNS = [
  { id: 1, hebrewName: "תעודת זהות", name: "passport", isDefault: true },
  { id: 2, hebrewName: "שם מטופל", name: "patientName", isDefault: true },
  { id: 3, hebrewName: "טלפון", name: "patient_phone", isDefault: true },
  { id: 4, hebrewName: "תאריך", name: "date", isDefault: true },
  { id: 5, hebrewName: "שעה", name: "hour", isDefault: false },
  { id: 6, hebrewName: "גיל", name: "patient_age", isDefault: true },
  { id: 7, hebrewName: "סוג התור", name: "type", isDefault: true },
  { id: 8, hebrewName: "גורם משלם", name: "insurance_name", isDefault: true },
  { id: 9, hebrewName: "עלות", name: "fee", isDefault: true },
  {
    id: 10,
    hebrewName: "אישור הגעה",
    name: "arrival_status",
    isDefault: false
  },
  { id: 11, hebrewName: "מקור שיבוץ", name: "scheduled_by", isDefault: false },
  { id: 12, hebrewName: "מגדר", name: "patient_gender", isDefault: false },
  {
    id: 13,
    hebrewName: "מסמכים",
    name: "documents_count",
    isDefault: false
  },
  { id: 14, hebrewName: "דחיפות", name: "alert_type", isDefault: false }
];

/**
 * Initial settings for surgery
 * columns.
 */
export const SURGERY_COLUMNS = [
  { id: 1, hebrewName: "תעודת זהות", name: "passport", isDefault: true },
  { id: 2, hebrewName: "שם מטופל", name: "patientName", isDefault: true },
  { id: 3, hebrewName: "טלפון", name: "patient_phone", isDefault: true },
  { id: 4, hebrewName: "תאריך", name: "date", isDefault: true },
  { id: 5, hebrewName: "שעה", name: "hour", isDefault: false },
  { id: 6, hebrewName: "גיל", name: "patient_age", isDefault: true },
  { id: 7, hebrewName: "סטטוס ניתוח", name: "status_heb", isDefault: false },
  {
    id: 8,
    hebrewName: "סטטוס התחייבות",
    name: "insurance_status_heb",
    isDefault: false
  },
  {
    id: 9,
    hebrewName: "מספר התחייבות",
    name: "insurance_code",
    isDefault: false
  },
  { id: 10, hebrewName: "גורם משלם", name: "insurance_name", isDefault: true },
  {
    id: 11,
    hebrewName: "השתתפות עצמית",
    name: "insurance_fee",
    isDefault: false
  },
  { id: 12, hebrewName: "חדר", name: "room", isDefault: false },
  { id: 13, hebrewName: "מגדר", name: "patient_gender", isDefault: false },
  { id: 14, hebrewName: "שם ניתוח / פעולה", name: "title", isDefault: false },
  {
    id: 15,
    hebrewName: "מסמכים",
    name: "documents_count",
    isDefault: false
  },
  { id: 16, hebrewName: "דחיפות", name: "alert_type", isDefault: false }
];

/**
 * Initial settings for pathology
 * columns.
 */
export const PATHOLOGY_COLUMNS = [
  { id: 1, hebrewName: "תעודת זהות", name: "passport", isDefault: true },
  {
    id: 2,
    hebrewName: "מסמכים",
    name: "documents_count",
    isDefault: true
  },
  {
    id: 3,
    hebrewName: "זמינות המסמך למטופל",
    name: "is_available_online",
    isDefault: true
  },
  {
    id: 4,
    hebrewName: "סטטוס צפיית מטופל",
    name: "patient_view_status",
    isDefault: true
  },
  { id: 5, hebrewName: "תאריך המסמך", name: "created_at", isDefault: true },
  { id: 6, hebrewName: "שם פרטי", name: "first_name", isDefault: true },
  { id: 7, hebrewName: "שם משפחה", name: "last_name", isDefault: true },
  { id: 8, hebrewName: "טלפון", name: "phone", isDefault: true },
  { id: 9, hebrewName: "דחיפות", name: "alert_type", isDefault: false }
];

/**
 * Initial settings for ivf
 * columns.
 */
export const IVF_COLUMNS = [
  { id: 1, hebrewName: "תעודת זהות", name: "passport", isDefault: true },
  { id: 2, hebrewName: "שם מטופל", name: "patientName", isDefault: true },
  { id: 3, hebrewName: "טלפון", name: "patient_phone", isDefault: true },
  { id: 4, hebrewName: "סוג התור", name: "type", isDefault: true },
  {
    id: 5,
    hebrewName: "מסמכים קיימים",
    name: "existing_files",
    isDefault: true
  },
  {
    id: 6,
    hebrewName: "מסמכים חסרים",
    name: "missing_files",
    isDefault: true
  },
  {
    id: 7,
    hebrewName: "טפסי הסכמה",
    name: "ivf_button",
    isDefault: true
  }
];
